enum MobileMode {
  Auto = 'auto',
  Enable = 'enable',
  Disable = 'disable',
}

export default MobileMode;
